import { Injector, NgModule, inject } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { ApolloLink, DefaultOptions, InMemoryCache } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import {
  EnterpriseSearchService,
  Environment,
  LogonService,
  WebTokenService
} from '@sabstravtech/obtservices/angular';
import { HttpLink } from 'apollo-angular/http';

import { environment } from '../../environments/environment';
import { LightningEnterpriseSearchService } from '../core/services/search.service';

const PROVIDERS = [
  { provide: Environment, useValue: environment },
  {
    provide: EnterpriseSearchService,
    useClass: LightningEnterpriseSearchService
  },
  provideApollo(() => {
    const httpLink = inject(HttpLink);
    const webTokenService = inject(WebTokenService);
    const injector = inject(Injector);

    const defaultOptions: DefaultOptions = {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore'
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    };

    const http = httpLink.create({
      uri: environment.requestURL
    });
    const middleware = new ApolloLink((operation, forward) => {
      operation.setContext({
        headers: webTokenService.getHeaders()
      });
      return forward(operation);
    });

    // When the graphql gateway rejects a JWT with 401 (e.g. the session was
    // invalidated by another login), trigger a refresh-token call. The auth
    // service responds with "Session displaced by another login", which
    // LogonService already handles by showing the "Session Ended" modal.
    // LogonService is resolved lazily via the injector to avoid a circular
    // DI with Apollo (LogonService transitively depends on Apollo).
    const errorLink = onError(({ networkError }) => {
      if (!networkError) {
        return;
      }
      const anyErr = networkError as any;
      const status = anyErr?.status ?? anyErr?.statusCode ?? anyErr?.response?.status;
      console.debug('[apollo onError] networkError', { status, networkError });
      if (status === 401) {
        injector.get(LogonService).refreshToken();
      }
    });

    const link = errorLink.concat(middleware).concat(http);
    return {
      cache: new InMemoryCache(),
      link,
      connectToDevTools: true,
      defaultOptions: defaultOptions
    };
  })
];

@NgModule({
  providers: PROVIDERS
})
export class OverRiddenModule {}
